import { useState } from 'react';

import { useCFPPlatform } from '@bcp-channels-sharedcomponents-reactjs/cf-proxy';
import { useDidMount } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

export const useResponsive = () => {
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	const { platform } = useCFPPlatform();

	useDidMount(() => {
		const handleResizeScreen = () => setWindowWidth(window.innerWidth);

		window.addEventListener('resize', handleResizeScreen);

		return () => {
			window.removeEventListener('resize', handleResizeScreen);
		};
	});

	return { platform, windowWidth };
};
